import { TemperatureDisplay } from './components/TemperatureDisplay';
import './App.css';

function App() {
    return (
        <div className="App">
            <TemperatureDisplay />
        </div>
    );
}

export default App;